export const business_model =[
  'B2B',
  'B2C',
  'B2B2C',
  'BTG'
]

export const days_of_week = [
  'Monday', 
  'Tuesday', 
  'Wednesday', 
  'Thursday', 
  'Friday', 
  'Saturday', 
  'Sunday'
]

export const days_of_month = [
  '1', 
  '2', 
  '3', 
  '4', 
  '5', 
  '6', 
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31'
]

export const frequencies = [
  // 'Hourly', 
  'Daily', 
  'Weekly', 
  'Monthly'
]

///////////////////////////////


export const devices = [
  'Desktop & Mobile',
]

export const brands = [
  'TRUE',
  'FALSE'
]



////////////////////////////////////////////////
export const verticals = [
  'Arts and Entertainment',
  'Automotive',
  'Beauty and Fitness',
  'Books and Literature',
  'Business and Industrial Markets',
  'Computers and Electronics',
  'Finance',
  'Food and Drink',
  'Games',
  'Healthcare',
  'Hobbies and Leisure',
  'Home and Garden',
  'Internet and Telecom',
  'Jobs and Education',
  'Law and Government',
  'News',
  'Online Communities',
  'People and Society',
  'Pets and Animals',
  'Real Estate',
  'Reference',
  'Science',
  'Shopping',
  'Sports',
  'Travel',
  'Other'
]



//////////////////////////
export const industries = [
'Accommodation',
'Aerospace and Defense',
'Agriculture',
'Arts and Culture',
'Automotive',
'Biotechnology',
'Chemicals',
'Construction',
'Consumer Goods',
'E-commerce',
'Education',
'Energy',
'Environmental Services',
'Financial Services',
'Food Services',
'Gambling and Betting',
'Government Services',
'Health Care',
'Horticulture',
'Humanitarian Aid',
'Insurance',
'IT & Communications',
'Life Sciences',
'Logistics',
'Manufacturing',
'Media and Entertainment',
'Medical Devices',
'Mining',
'Non-profit',
'Personal Services',
'Pharmaceuticals',
'Professional Services',
'Public Sector',
'Real Estate',
'Recruitment',
'Retail',
'Security Services',
'Social Care',
'Software Development',
'Space Exploration',
'Sports and Fitness',
'Technology',
'Telecommunications',
'Transportation',
'Travel and Tourism',
'Virtual and Augmented Reality',
'Waste Management'
]

export const metrics = [
'Industry Benchmarks',
'Competitor Positioning',
'Page One Visibility',
'Organic Performance',
'Paid Performance',
'Other'
]

//////////////////////////
export const companies = [
  'Serpr',
  'Found',
  'Disrupt',
  'Company1',
  'Company2',
  'Company3',
  'Another Company',
]

export const websites= [
  'www.serpr.co.uk',
  'www.braidr.co.uk',
  'www.disrupt.co.uk',
  'www.found.co.uk',

]




//////////////////////////
export const google_domains = [
  'google.co.uk',
  'google.com',
  'google.ro'
]




////////////////////////////

export const countries = [
'Afghanistan','Albania','Algeria','American Samoa','Andorra','Angola','Anguilla','Antigua and Barbuda','Argentina','Armenia','Australia','Austria','Azerbaijan','Bahamas','Bahrain','Bangladesh','Belarus','Belgium','Belize','Benin','Bhutan','Bolivia','Bosnia and Herzegovina','Botswana','Brazil','British Virgin Islands','Brunei','Bulgaria','Burkina Faso','Burundi','Cambodia','Cameroon','Canada','Cape Verde','Central African Republic','Chad','Chile','Colombia','Cook Islands','Costa Rica','Croatia','Cuba','Cyprus','Czech Republic','Democratic Republic of the Congo','Denmark','Djibouti','Dominica','Dominican Republic','Ecuador','Egypt','El Salvador','Estonia','Ethiopia','Fiji','Finland','France','Gabon','Gambia','Georgia','Germany','Ghana','Gibraltar','Greece','Greenland','Guadeloupe','Guatemala','Guyana','Haiti','Honduras','Hong Kong','Hungary','Iceland','India','Indonesia','Iraq','Ireland','Israel','Italy','Ivory Coast','Jamaica','Japan','Jordan','Kazakhstan','Kenya','Kiribati','Kuwait','Kyrgyzstan','Laos','Latvia','Lebanon','Lesotho','Libya','Liechtenstein','Lithuania','Luxembourg','Macedonia','Madagascar','Malawi','Malaysia','Maldives','Mali','Malta','Mauritius','Mexico','Moldova','Mongolia','Montserrat','Morocco','Mozambique','Myanmar','Namibia','Nauru','Nepal','Netherlands','New Zealand','Nicaragua','Niger','Nigeria','Niue','Norway','Oman','Pakistan','Palestine','Panama','Papua New Guinea','Paraguay','Peru','Philippines','Poland','Portugal','Puerto Rico','Qatar','Republic of the Congo','Romania','Russia','Rwanda','Saint Helena','Samoa','San Marino','Saudi Arabia','Senegal','Serbia','Seychelles','Sierra Leone','Singapore','Slovakia','Slovenia','Solomon Islands','Somalia','South Africa','South Korea','Spain','Sri Lanka','Suriname','Sweden','Switzerland','Taiwan','Tajikistan','Tanzania','Thailand','Timor-Leste','Togo','Tokelau','Tonga','Trinidad and Tobago','Tunisia','Turkey','Turkmenistan','Uganda','Ukraine','United Arab Emirates','United Kingdom','United States Virgin Islands','United States','Uruguay','Uzbekistan','Vanuatu','Venezuela','Vietnam','Zambia','Zimbabwe'
]

export const types = [
  'B2B',
  'B2C'
]

export const locations = [
   {
      id: '1006886',
      name: 'London, England, United Kingdom',
      country: 'England'
  },

  {
      id: '1023191',
      name: 'New York, New York, United States',
      country: 'USA'
  },
  
  {
      id: '9041083',
      name: 'Dubai, United Arab Emirates',
      country: 'United Arab Emirates'
  },

  {
      id: '1003854',
      name: 'Berlin, Berlin, Germany',
      country: 'Germany'
  },

  {
      id: '9040871',
      name: 'Paris, Ile-de-France, France',
      country: 'France'
  },
]

export const locations2 =[ 
  'London, England, United Kingdom',
  'New York, New York, United States',
  'Dubai, United Arab Emirates',
  'Berlin, Berlin, Germany',
  'Paris, Ile-de-France, France',
]

//////////////////////////

export const languages2 = [
"Afrikaans",
"Akan",
"Albanian",
"Samoa",
"Amharic",
"Arabic",
"Armenian",
"Azerbaijani",
"Basque",
"Belarusian",
"Bemba",
"Bengali",
"Bihari",
"Bork, bork, bork!",
"Bosnian",
"Breton",
"Bulgarian",
"Bhutanese",
"Cambodian",
"Catalan",
"Cherokee",
"Chichewa",
"Chinese (Simplified)",
"Chinese (Traditional)",
"Corsican",
"Croatian",
"Czech",
"Danish",
"Dutch",
"Elmer Fudd",
"English",
"Esperanto",
"Estonian",
"Ewe",
"Faroese",
"Filipino",
"Finnish",
"French",
"Frisian",
"Ga",
"Galician",
"Georgian",
"German",
"Greek",
"Greenlandic",
"Guarani",
"Gujarati",
"Hacker",
"Haitian Creole",
"Hausa",
"Hawaiian",
"Hebrew",
"Hindi",
"Hungarian",
"Icelandic",
"Igbo",
"Indonesian",
"Interlingua",
"Irish",
"Italian",
"Japanese",
"Javanese",
"Kannada",
"Kazakh",
"Kinyarwanda",
"Kirundi",
"Klingon",
"Kongo",
"Korean",
"Krio (Sierra Leone)",
"Kurdish",
"Kurdish (Soranî)",
"Kyrgyz",
"Laothian",
"Latin",
"Latvian",
"Lingala",
"Lithuanian",
"Lozi",
"Luganda",
"Luo",
"Macedonian",
"Malagasy",
"Malay",
"Malayalam",
"Maltese",
"Maldives",
"Maori",
"Marathi",
"Mauritian Creole",
"Moldavian",
"Mongolian",
"Montenegrin",
"Nepali",
"Nigerian Pidgin",
"Northern Sotho",
"Norwegian",
"Norwegian (Nynorsk)",
"Occitan",
"Oriya",
"Oromo",
"Pashto",
"Persian",
"Pirate",
"Polish",
"Portuguese",
"Portuguese (Brazil)",
"Portuguese (Portugal)",
"Punjabi",
"Quechua",
"Romanian",
"Romansh",
"Runyakitara",
"Russian",
"Scots Gaelic",
"Serbian",
"Serbo-Croatian",
"Sesotho",
"Setswana",
"Seychellois Creole",
"Shona",
"Sindhi",
"Sinhalese",
"Slovak",
"Slovenian",
"Somali",
"Southern Ndebele",
"Southern Sotho",
"Spanish",
"Sundanese",
"Swahili",
"Swati",
"Swedish",
"Tagalog",
"Tahitian",
"Tajik",
"Tamil",
"Tatar",
"Telugu",
"Thai",
"Tibetan",
"Tigrinya",
"Tonga",
"Tsonga",
"Turkish",
"Turkmen",
"Twi",
"Uighur",
"Ukrainian",
"Urdu",
"Uzbek",
"Venda",
"Vietnamese",
"Volapük",
"Walloon",
"Welsh",
"West Frisian",
"Wolof",
"Xhosa",
"Yiddish",
"Yoruba",
"Zulu"
]


//////////////////////////
export const roles = [
  'Admin',
  'Manager',
  'Editor',
  'Viewer',
]


export const Audience = [
  'Accommodation',
  'Aviation',
  'Business',
  'Charity',
  'Construction',
  'Consulting',
  'Cosmetics',
  'Couriers',
  'Cyber security',
  'Marketing',
  'DIY',
  'Ecommerce',
  'Accommodation',
  'Aviation',
  'Business',
  'Charity',
  'Construction',
  'Consulting',
  'Cosmetics',
  'Couriers',
  'Cyber security',
  'Marketing',
  'DIY',
  'Ecommerce',
]


export const onboardedWebsites = [
  {
      id: '70',
      name: 'Napier',
      industry: 'finance',
      theme: 'Unkwnon',
      website: 'napier.co.uk'
  },
  {
      id: '59',
      name: 'Found',
      industry: 'internet and telecom',
      theme: 'Unkwnon',
      website: 'found.co.uk'
  },
  {
      id: '79',
      name: 'Secret Sales',
      industry: 'shopping',
      theme: 'Unkwnon',
      website: 'secret-sales.co.uk'
  },
  {
     id: '92',
     name: 'PwC US',
     industry: 'shopping',
     theme: 'Unkwnon',
     website: 'pwc.co.uk'
 },

 {
      id: '131',
      name: 'Puma',
      industry: 'shopping',
      theme: 'Unkwnon',
      website: 'puma.co.uk'
  },
  {
      id: '139',
      name: 'Babease',
      industry: 'shopping',
      theme: 'Unkwnon',
      website: 'babease.co.uk'
  },
  {
      id: '136',
      name: 'Solos Holidays',
      industry: 'shopping',
      theme: 'Unkwnon',
      website: 'solos-holidays.co.uk'
  },
  {
      id: '137',
      name: 'Global Web Index',
      industry: 'shopping',
      theme: 'Unkwnon',
      website: 'gwi.co.uk'
  },
  {
      id: '132',
      name: 'The Hoxton',
      industry: 'shopping',
      theme: 'Unkwnon',
      website: 'the-hoxton.co.uk'
  },

  {
    id: '215',
    name: 'Boux Avenue',
    industry: 'shopping',
    theme: 'Unkwnon',
    website: 'bouxavenue.com'
},

]

export const locationsLegend = {

  'Andorra' :   {
        "A": "Andorra",
        "B": "ad",
        "C": "Andorra",
        "D": "google.ad",
        "E": ""
      },
      'United Arab Emirates' :    {
        "A": "United Arab Emirates",
        "B": "ae",
        "C": "Dubai,United Arab Emirates",
        "D": "google.ae",
        "E": ""
      },
      "Albania" : {
        "A": "Albania",
        "B": "al",
        "C": "Albania",
        "D": "google.al",
        "E": ""
      },
      "Armenia" : {
        "A": "Armenia",
        "B": "am",
        "C": "Kotayk Province,Armenia",
        "D": "google.am",
        "E": ""
      },
      "American Samoa" :  {
        "A": "American Samoa",
        "B": "as",
        "C": "American Samoa",
        "D": "google.as",
        "E": ""
      },
      "Austria" : {
        "A": "Austria",
        "B": "at",
        "C": "Innere Stadt,Vienna,Austria",
        "D": "google.at",
        "E": ""
      },
      "Azerbaijan" : {
        "A": "Azerbaijan",
        "B": "az",
        "C": "Azerbaijan",
        "D": "google.az",
        "E": ""
      },
      "Bosnia and Herzegovina" : {
        "A": "Bosnia and Herzegovina",
        "B": "ba",
        "C": "Bosnia and Herzegovina",
        "D": "google.ba",
        "E": ""
      },
      "Belgium" :  {
        "A": "Belgium",
        "B": "be",
        "C": "Brussels,Belgium",
        "D": "google.be",
        "E": ""
      },
      "Burkina Faso" :  {
        "A": "Burkina Faso",
        "B": "bf",
        "C": "Burkina Faso",
        "D": "google.bf",
        "E": ""
      },
      "Bulgaria" : {
        "A": "Bulgaria",
        "B": "bg",
        "C": "Sofia,Sofia-Capital,Bulgaria",
        "D": "google.bg",
        "E": ""
      },
      "Burundi" : {
        "A": "Burundi",
        "B": "bi",
        "C": "Burundi",
        "D": "google.bi",
        "E": ""
      },
      "Benin" : {
        "A": "Benin",
        "B": "bj",
        "C": "Benin",
        "D": "google.bj",
        "E": ""
      },
      "Bahamas" : {
        "A": "Bahamas",
        "B": "bs",
        "C": "Bahamas",
        "D": "google.bs",
        "E": ""
      },
      "Bhutan" : {
        "A": "Bhutan",
        "B": "bt",
        "C": "Bhutan",
        "D": "google.bt",
        "E": ""
      },
      "Belarus" :  {
        "A": "Belarus",
        "B": "by",
        "C": "Belarus",
        "D": "google.by",
        "E": ""
      },
      "Canada" : {
        "A": "Canada",
        "B": "ca",
        "C": "M5V,Ontario,Canada",
        "D": "google.ca",
        "E": ""
      },
      "Democratic Republic of the Congo" : {
        "A": "Democratic Republic of the Congo",
        "B": "cg",
        "C": "Democratic Republic of the Congo",
        "D": "google.cd",
        "E": ""
      },
      "Central African Republic" : {
        "A": "Central African Republic",
        "B": "cf",
        "C": "Central African Republic",
        "D": "google.cf",
        "E": ""
      },
      "Republic of the Congo" : {
        "A": "Republic of the Congo",
        "B": "cg",
        "C": "Republic of the Congo",
        "D": "google.cg",
        "E": ""
      },
      "Switzerland" : {
        "A": "Switzerland",
        "B": "ch",
        "C": "Mitlodi,Canton of Glarus,Switzerland",
        "D": "google.ch",
        "E": ""
      },
      "Ivory Coast" : {
        "A": "Ivory Coast",
        "B": "ci",
        "C": "Vallee du Bandama District,Cote d'Ivoire",
        "D": "google.ci",
        "E": ""
      },
      "Chile" : {
        "A": "Chile",
        "B": "cl",
        "C": "Providencia,Santiago Metropolitan Region,Chile",
        "D": "google.cl",
        "E": ""
      },
      "Cameroon" : {
        "A": "Cameroon",
        "B": "cm",
        "C": "Cameroon",
        "D": "google.cm",
        "E": ""
      },
      "Angola" : {
        "A": "Angola",
        "B": "ao",
        "C": "Luanda Province,Angola",
        "D": "google.co.ao",
        "E": ""
      },
      "Botswana" : {
        "A": "Botswana",
        "B": "bw",
        "C": "South-East District,Botswana",
        "D": "google.co.bw",
        "E": ""
      },
      "Cook Islands" : {
        "A": "Cook Islands",
        "B": "ck",
        "C": "Cook Islands",
        "D": "google.co.ck",
        "E": ""
      },
      "Costa Rica" : {
        "A": "Costa Rica",
        "B": "cr",
        "C": "San Jose Province,Costa Rica",
        "D": "google.co.cr",
        "E": ""
      },
      "Indonesia" : {
        "A": "Indonesia",
        "B": "id",
        "C": "Jakarta,Jakarta,Indonesia",
        "D": "google.co.id",
        "E": ""
      },
      "Israel" : {
        "A": "Israel",
        "B": "il",
        "C": "Judea and Samaria Area,Israel",
        "D": "google.co.il",
        "E": ""
      },
      "India" : {
        "A": "India",
        "B": "in",
        "C": "110001,Delhi,India",
        "D": "google.co.in",
        "E": ""
      },
      "Japan" : {
        "A": "Japan",
        "B": "jp",
        "C": "Tokyo,Japan",
        "D": "google.co.jp",
        "E": ""
      },
      "Kenya" : {
        "A": "Kenya",
        "B": "ke",
        "C": "Kenya",
        "D": "google.co.ke",
        "E": ""
      },
      "South Korea" : {
        "A": "South Korea",
        "B": "kr",
        "C": "Jinhae-gu,Gyeongsangnam-do,South Korea",
        "D": "google.co.kr",
        "E": ""
      },
      "Lesotho" : {
        "A": "Lesotho",
        "B": "ls",
        "C": "Lesotho",
        "D": "google.co.ls",
        "E": ""
      },
      "Morocco" : {
        "A": "Morocco",
        "B": "ma",
        "C": "Morocco",
        "D": "google.co.ma",
        "E": ""
      },
      "Mozambique" : {
        "A": "Mozambique",
        "B": "mz",
        "C": "Maputo Province,Mozambique",
        "D": "google.co.mz",
        "E": ""
      },
      "New Zealand" : {
        "A": "New Zealand",
        "B": "nz",
        "C": "Waitakere,Auckland,New Zealand",
        "D": "google.co.nz",
        "E": ""
      },
      "Thailand" : {
        "A": "Thailand",
        "B": "th",
        "C": "Bangkok,Thailand",
        "D": "google.co.th",
        "E": ""
      },
      "Tanzania" : {
        "A": "Tanzania",
        "B": "tz",
        "C": "Tanzania",
        "D": "google.co.tz",
        "E": ""
      },
      "Uganda" : {
        "A": "Uganda",
        "B": "ug",
        "C": "Uganda",
        "D": "google.co.ug",
        "E": ""
      },
      "United Kingdom" : {
        "A": "United Kingdom",
        "B": "gb",
        "C": "N1,England,United Kingdom",
        "D": "google.co.uk",
        "E": ""
      },
      "Uzbekistan" : {
        "A": "Uzbekistan",
        "B": "uz",
        "C": "Uzbekistan",
        "D": "google.co.uz",
        "E": ""
      },
      "Venezuela" : {
        "A": "Venezuela",
        "B": "ve",
        "C": "Capital District,Venezuela",
        "D": "google.co.ve",
        "E": ""
      },
      "United States Virgin Islands" : {
        "A": "United States Virgin Islands",
        "B": "vi",
        "C": "St. Thomas,U.S. Virgin Islands",
        "D": "google.co.vi",
        "E": ""
      },
      "South Africa" : {
        "A": "South Africa",
        "B": "za",
        "C": "Gauteng,South Africa",
        "D": "google.co.za",
        "E": ""
      },
      "Zambia" : {
        "A": "Zambia",
        "B": "zm",
        "C": "Lusaka Province,Zambia",
        "D": "google.co.zm",
        "E": ""
      },
      "Zimbabwe" : {
        "A": "Zimbabwe",
        "B": "zw",
        "C": "Harare Province,Zimbabwe",
        "D": "google.co.zw",
        "E": ""
      },
      "United States" : {
        "A": "United States",
        "B": "us",
        "C": "60601,Illinois,United States",
        "D": "google.com",
        "E": ""
      },
      "Afghanistan" : {
        "A": "Afghanistan",
        "B": "af",
        "C": "Afghanistan",
        "D": "google.com.af",
        "E": ""
      },
      "Antigua and Barbuda" : {
        "A": "Antigua and Barbuda",
        "B": "ag",
        "C": "Antigua and Barbuda",
        "D": "google.com.ag",
        "E": ""
      },
      "Anguilla" : {
        "A": "Anguilla",
        "B": "ai",
        "C": "Anguilla",
        "D": "google.com.ai",
        "E": ""
      },
      "Argentina" : {
        "A": "Argentina",
        "B": "ar",
        "C": "Buenos Aires,Argentina",
        "D": "google.com.ar",
        "E": ""
      },
      "Australia" : {
        "A": "Australia",
        "B": "au",
        "C": "2000,New South Wales,Australia",
        "D": "google.com.au",
        "E": ""
      },
      "Bangladesh" : {
        "A": "Bangladesh",
        "B": "bd",
        "C": "Dhaka District,Dhaka Division,Bangladesh",
        "D": "google.com.bd",
        "E": ""
      },
      "Bahrain" : {
        "A": "Bahrain",
        "B": "bh",
        "C": "Bahrain",
        "D": "google.com.bh",
        "E": ""
      },
      "Brunei" : {
        "A": "Brunei",
        "B": "bn",
        "C": "Brunei-Muara District,Brunei",
        "D": "google.com.bn",
        "E": ""
      },
      "Bolivia" : {
        "A": "Bolivia",
        "B": "bo",
        "C": "Bolivia",
        "D": "google.com.bo",
        "E": ""
      },
      "Brazil" : {
        "A": "Brazil",
        "B": "br",
        "C": "Brazil",
        "D": "google.com.br",
        "E": ""
      },
      "Belize" : {
        "A": "Belize",
        "B": "bz",
        "C": "Belize District,Belize",
        "D": "google.com.bz",
        "E": ""
      },
      "Colombia" : {
        "A": "Colombia",
        "B": "co",
        "C": "Santa Marta,Magdalena,Colombia",
        "D": "google.com.co",
        "E": ""
      },
      "Cuba" : {
        "A": "Cuba",
        "B": "cu",
        "C": "Cuba",
        "D": "google.com.cu",
        "E": ""
      },
      "Cyprus" : {
        "A": "Cyprus",
        "B": "cy",
        "C": "Limassol,Cyprus",
        "D": "google.com.cy",
        "E": ""
      },
      "Dominican Republic" : {
        "A": "Dominican Republic",
        "B": "do",
        "C": "Distrito Nacional,Dominican Republic",
        "D": "google.com.do",
        "E": ""
      },
      "Ecuador" : {
        "A": "Ecuador",
        "B": "ec",
        "C": "Pichincha,Ecuador",
        "D": "google.com.ec",
        "E": ""
      },
      "Egypt" : {
        "A": "Egypt",
        "B": "eg",
        "C": "Egypt",
        "D": "google.com.eg",
        "E": ""
      },
      "Ethiopia" : {
        "A": "Ethiopia",
        "B": "et",
        "C": "Ethiopia",
        "D": "google.com.et",
        "E": ""
      },
      "Fiji" : {
        "A": "Fiji",
        "B": "fj",
        "C": "Fiji",
        "D": "google.com.fj",
        "E": ""
      },
      "Ghana" : {
        "A": "Ghana",
        "B": "gh",
        "C": "Ghana",
        "D": "google.com.gh",
        "E": ""
      },
      "Gibraltar" : {
        "A": "Gibraltar",
        "B": "gi",
        "C": "Gibraltar",
        "D": "google.com.gi",
        "E": ""
      },
      "Guatemala" : {
        "A": "Guatemala",
        "B": "gt",
        "C": "Guatemala",
        "D": "google.com.gt",
        "E": ""
      },
      "Hong Kong" : {
        "A": "Hong Kong",
        "B": "hk",
        "C": "Mong Kok,Kowloon,Hong Kong",
        "D": "google.com.hk",
        "E": ""
      },
      "Jamaica" : {
        "A": "Jamaica",
        "B": "jm",
        "C": "Jamaica",
        "D": "google.com.jm",
        "E": ""
      },
      "Cambodia" : {
        "A": "Cambodia",
        "B": "kh",
        "C": "Phnom Penh,Cambodia",
        "D": "google.com.kh",
        "E": ""
      },
      "Kuwait" : {
        "A": "Kuwait",
        "B": "kw",
        "C": "Kuwait",
        "D": "google.com.kw",
        "E": ""
      },
      "Lebanon" : {
        "A": "Lebanon",
        "B": "lb",
        "C": "Lebanon",
        "D": "google.com.lb",
        "E": ""
      },
      "Libya" : {
        "A": "Libya",
        "B": "ly",
        "C": "Tripoli District,Libya",
        "D": "google.com.ly",
        "E": ""
      },
      "Myanmar" : {
        "A": "Myanmar",
        "B": "mm",
        "C": "Myanmar",
        "D": "google.com.mm",
        "E": ""
      },
      "Malta" : {
        "A": "Malta",
        "B": "mt",
        "C": "Malta",
        "D": "google.com.mt",
        "E": ""
      },
      "Mexico" : {
        "A": "Mexico",
        "B": "mx",
        "C": "Coyoacan,Mexico City,Mexico",
        "D": "google.com.mx",
        "E": ""
      },
      "Malaysia" : {
        "A": "Malaysia",
        "B": "my",
        "C": "55100,Federal Territory of Kuala Lumpur,Malaysia",
        "D": "google.com.my",
        "E": ""
      },
      "Namibia" : {
        "A": "Namibia",
        "B": "na",
        "C": "Namibia",
        "D": "google.com.na",
        "E": ""
      },
      "Nigeria" : {
        "A": "Nigeria",
        "B": "ng",
        "C": "Ozoro,Delta,Nigeria",
        "D": "google.com.ng",
        "E": ""
      },
      "Nicaragua" : {
        "A": "Nicaragua",
        "B": "ni",
        "C": "Nicaragua",
        "D": "google.com.ni",
        "E": ""
      },
      "Nepal" : {
        "A": "Nepal",
        "B": "np",
        "C": "Nepal",
        "D": "google.com.np",
        "E": ""
      },
      "Oman" : {
        "A": "Oman",
        "B": "om",
        "C": "Oman",
        "D": "google.com.om",
        "E": ""
      },
      "Panama" : {
        "A": "Panama",
        "B": "pa",
        "C": "Panama,Panama",
        "D": "google.com.pa",
        "E": ""
      },
      "Peru" : {
        "A": "Peru",
        "B": "pe",
        "C": "Lima,Lima Province,Peru",
        "D": "google.com.pe",
        "E": ""
      },
      "Papua New Guinea" : {
        "A": "Papua New Guinea",
        "B": "pg",
        "C": "Boroko,Papua New Guinea",
        "D": "google.com.pg",
        "E": ""
      },
      "Philippines" : {
        "A": "Philippines",
        "B": "ph",
        "C": "Cebu,Central Visayas,Philippines",
        "D": "google.com.ph",
        "E": ""
      },
      "Pakistan" : {
        "A": "Pakistan",
        "B": "pk",
        "C": "Pakistan",
        "D": "google.com.pk",
        "E": ""
      },
      "Puerto Rico" : {
        "A": "Puerto Rico",
        "B": "pr",
        "C": "San Juan,Puerto Rico",
        "D": "google.com.pr",
        "E": ""
      },
      "Paraguay" : {
        "A": "Paraguay",
        "B": "py",
        "C": "Paraguay",
        "D": "google.com.py",
        "E": ""
      },
      "Qatar" : {
        "A": "Qatar",
        "B": "qa",
        "C": "Doha,Qatar",
        "D": "google.com.qa",
        "E": ""
      },
      "Saudi Arabia" : {
        "A": "Saudi Arabia",
        "B": "sa",
        "C": "Makkah Province,Saudi Arabia",
        "D": "google.com.sa",
        "E": ""
      },
      "Solomon Islands" : {
        "A": "Solomon Islands",
        "B": "sb",
        "C": "Solomon Islands",
        "D": "google.com.sb",
        "E": ""
      },
      "Singapore" : {
        "A": "Singapore",
        "B": "sg",
        "C": "Kallang,Singapore",
        "D": "google.com.sg",
        "E": ""
      },
      "Sierra Leone" : {
        "A": "Sierra Leone",
        "B": "sl",
        "C": "Sierra Leone",
        "D": "google.com.sl",
        "E": ""
      },
      "El Salvador" : {
        "A": "El Salvador",
        "B": "sv",
        "C": "El Salvador",
        "D": "google.com.sv",
        "E": ""
      },
      "Tajikistan" : {
        "A": "Tajikistan",
        "B": "tj",
        "C": "Districts of Republican Subordination,Tajikistan",
        "D": "google.com.tj",
        "E": ""
      },
      "Turkey" : {
        "A": "Turkey",
        "B": "tr",
        "C": "Istanbul,Turkey",
        "D": "google.com.tr",
        "E": ""
      },
      "Taiwan" : {
        "A": "Taiwan",
        "B": "tw",
        "C": "Tamsui District,New Taipei City,Taiwan",
        "D": "google.com.tw",
        "E": ""
      },
      "Ukraine" : {
        "A": "Ukraine",
        "B": "ua",
        "C": "Shevchenkivs'kyi district,Kyiv city,Ukraine",
        "D": "google.com.ua",
        "E": ""
      },
      "Uruguay" : {
        "A": "Uruguay",
        "B": "uy",
        "C": "Uruguay",
        "D": "google.com.uy",
        "E": ""
      },
      "Saint Vincent and the Grenadines" : {
        "A": "Saint Vincent and the Grenadines",
        "B": "vc",
        "C": "Saint Vincent and the Grenadines",
        "D": "google.com.vc",
        "E": ""
      },
      "Vietnam" : {
        "A": "Vietnam",
        "B": "vn",
        "C": "Ho Chi Minh City,Vietnam",
        "D": "google.com.vn",
        "E": ""
      },
      "Cape Verde" : {
        "A": "Cape Verde",
        "B": "cv",
        "C": "Cape Verde",
        "D": "google.cv",
        "E": ""
      },
      "Czech Republic" : {
        "A": "Czech Republic",
        "B": "cz",
        "C": "110 00,Prague,Czechia",
        "D": "google.cz",
        "E": ""
      },
      "Germany" : {
        "A": "Germany",
        "B": "de",
        "C": "80538,Bavaria,Germany",
        "D": "google.de",
        "E": ""
      },
      "Djibouti" : {
        "A": "Djibouti",
        "B": "dj",
        "C": "Djibouti",
        "D": "google.dj",
        "E": ""
      },
      "Denmark" : {
        "A": "Denmark",
        "B": "dk",
        "C": "Valby,Capital Region of Denmark,Denmark",
        "D": "google.dk",
        "E": ""
      },
      "Dominica" : {
        "A": "Dominica",
        "B": "dm",
        "C": "Dominica",
        "D": "google.dm",
        "E": ""
      },
      "Algeria" :  {
        "A": "Algeria",
        "B": "dz",
        "C": "Algiers Province,Algeria",
        "D": "google.dz",
        "E": ""
      },
      "Estonia" : {
        "A": "Estonia",
        "B": "ee",
        "C": "Tartu Parish,Tartu County,Estonia",
        "D": "google.ee",
        "E": ""
      },
      "Spain" : {
        "A": "Spain",
        "B": "es",
        "C": "Province of Barcelona,Catalonia,Spain",
        "D": "google.es",
        "E": ""
      },
      "Finland" : {
        "A": "Finland",
        "B": "fi",
        "C": "Helsinki,Finland",
        "D": "google.fi",
        "E": ""
      },
      "Micronesia, Federated States of" : {
        "A": "Micronesia, Federated States of",
        "B": "fm",
        "C": "Micronesia, Federated States of",
        "D": "google.fm",
        "E": ""
      },
      "France" : {
        "A": "France",
        "B": "fr",
        "C": "75001,Ile-de-France,France",
        "D": "google.fr",
        "E": ""
      },
      "Gabon" : {
        "A": "Gabon",
        "B": "ga",
        "C": "Gabon",
        "D": "google.ga",
        "E": ""
      },
      "Georgia" : {
        "A": "Georgia",
        "B": "ge",
        "C": "Georgia",
        "D": "google.ge",
        "E": ""
      },
      "Greenland" : {
        "A": "Greenland",
        "B": "gl",
        "C": "Sermersooq Municipality,Greenland",
        "D": "google.gl",
        "E": ""
      },
      "Gambia" : {
        "A": "Gambia",
        "B": "gm",
        "C": "Gambia",
        "D": "google.gm",
        "E": ""
      },
      "Guadeloupe" : {
        "A": "Guadeloupe",
        "B": "gp",
        "C": "Guadeloupe",
        "D": "google.gp",
        "E": ""
      },
      "Greece" : {
        "A": "Greece",
        "B": "gr",
        "C": "Kallithea,Attica,Greece",
        "D": "google.gr",
        "E": ""
      },
      "Guyana" : {
        "A": "Guyana",
        "B": "gy",
        "C": "Guyana",
        "D": "google.gy",
        "E": ""
      },
      "Honduras" : {
        "A": "Honduras",
        "B": "hn",
        "C": "Honduras",
        "D": "google.hn",
        "E": ""
      },
      "Croatia" : {
        "A": "Croatia",
        "B": "hr",
        "C": "Croatia",
        "D": "google.hr",
        "E": ""
      },
      "Haiti" : {
        "A": "Haiti",
        "B": "ht",
        "C": "Haiti",
        "D": "google.ht",
        "E": ""
      },
      "Hungary" : {
        "A": "Hungary",
        "B": "hu",
        "C": "1138,Budapest,Hungary",
        "D": "google.hu",
        "E": ""
      },
      "Ireland" : {
        "A": "Ireland",
        "B": "ie",
        "C": "Stillorgan,County Dublin,Ireland",
        "D": "google.ie",
        "E": ""
      },
      "Iraq" : {
        "A": "Iraq",
        "B": "iq",
        "C": "Iraq",
        "D": "google.iq",
        "E": ""
      },
      "Iceland" : {
        "A": "Iceland",
        "B": "is",
        "C": "Iceland",
        "D": "google.is",
        "E": ""
      },
      "Italy" : {
        "A": "Italy",
        "B": "it",
        "C": "Metropolitan City of Milan,Lombardy,Italy",
        "D": "google.it",
        "E": ""
      },
      "Jordan" : {
        "A": "Jordan",
        "B": "jo",
        "C": "Jordan",
        "D": "google.jo",
        "E": ""
      },
      "Kyrgyzstan" : {
        "A": "Kyrgyzstan",
        "B": "kg",
        "C": "Talas Region,Kyrgyzstan",
        "D": "google.kg",
        "E": ""
      },
      "Kiribati" : {
        "A": "Kiribati",
        "B": "ki",
        "C": "Kiribati",
        "D": "google.ki",
        "E": ""
      },
      "Kazakhstan" : {
        "A": "Kazakhstan",
        "B": "kz",
        "C": "Almaty Province,Kazakhstan",
        "D": "google.kz",
        "E": ""
      },
      "Laos" : {
        "A": "Laos",
        "B": "la",
        "C": "Vientiane Prefecture,Laos",
        "D": "google.la",
        "E": ""
      },
      "Liechtenstein" : {
        "A": "Liechtenstein",
        "B": "li",
        "C": "Schaan,Liechtenstein",
        "D": "google.li",
        "E": ""
      },
      "Sri Lanka" : {
        "A": "Sri Lanka",
        "B": "lk",
        "C": "Western Province,Sri Lanka",
        "D": "google.lk",
        "E": ""
      },
      "Lithuania" : {
        "A": "Lithuania",
        "B": "lt",
        "C": "Mazeikiai District Municipality,Telsiai County,Lithuania",
        "D": "google.lt",
        "E": ""
      },
      "Luxembourg" : {
        "A": "Luxembourg",
        "B": "lu",
        "C": "Kirchberg,Luxembourg",
        "D": "google.lu",
        "E": ""
      },
      "Latvia" : {
        "A": "Latvia",
        "B": "lv",
        "C": "Riga,Latvia",
        "D": "google.lv",
        "E": ""
      },
      "Moldova" : {
        "A": "Moldova",
        "B": "md",
        "C": "Balti,Moldova",
        "D": "google.md",
        "E": ""
      },
      "Madagascar" : {
        "A": "Madagascar",
        "B": "mg",
        "C": "Antananarivo Province,Madagascar",
        "D": "google.mg",
        "E": ""
      },
      "Macedonia" : {
        "A": "Macedonia",
        "B": "mk",
        "C": "Macedonia",
        "D": "google.mk",
        "E": ""
      },
      "Mali" : {
        "A": "Mali",
        "B": "ml",
        "C": "Mali",
        "D": "google.ml",
        "E": ""
      },
      "Mongolia" : {
        "A": "Mongolia",
        "B": "mn",
        "C": "Mongolia",
        "D": "google.mn",
        "E": ""
      },
      "Montserrat" : {
        "A": "Montserrat",
        "B": "ms",
        "C": "Montserrat",
        "D": "google.ms",
        "E": ""
      },
      "Mauritius" : {
        "A": "Mauritius",
        "B": "mu",
        "C": "Port Louis District,Mauritius",
        "D": "google.mu",
        "E": ""
      },
      "Maldives" : {
        "A": "Maldives",
        "B": "mv",
        "C": "Maldives",
        "D": "google.mv",
        "E": ""
      },
      "Malawi" : {
        "A": "Malawi",
        "B": "mw",
        "C": "Malawi",
        "D": "google.mw",
        "E": ""
      },
      "Niger" : {
        "A": "Niger",
        "B": "ne",
        "C": "Niger",
        "D": "google.ne",
        "E": ""
      },
      "Netherlands" : {
        "A": "Netherlands",
        "B": "nl",
        "C": "1012,North Holland,Netherlands",
        "D": "google.nl",
        "E": ""
      },
      "Norway" : {
        "A": "Norway",
        "B": "no",
        "C": "Oslo Municipality,Oslo,Norway",
        "D": "google.no",
        "E": ""
      },
      "Nauru" : {
        "A": "Nauru",
        "B": "nr",
        "C": "Nauru",
        "D": "google.nr",
        "E": ""
      },
      "Niue" : {
        "A": "Niue",
        "B": "nu",
        "C": "Niue",
        "D": "google.nu",
        "E": ""
      },
      "Poland" : {
        "A": "Poland",
        "B": "pl",
        "C": "Srodmiescie,Masovian Voivodeship,Poland",
        "D": "google.pl",
        "E": ""
      },
      "Palestine" : {
        "A": "Palestine",
        "B": "ps",
        "C": "Palestine",
        "D": "google.ps",
        "E": ""
      },
      "Portugal" : {
        "A": "Portugal",
        "B": "pt",
        "C": "Carvalhos,Porto District,Portugal",
        "D": "google.pt",
        "E": ""
      },
      "Romania" : {
        "A": "Romania",
        "B": "ro",
        "C": "900001,Constanta County,Romania",
        "D": "google.ro",
        "E": ""
      },
      "Serbia" : {
        "A": "Serbia",
        "B": "rs",
        "C": "Vojvodina,Serbia",
        "D": "google.rs",
        "E": ""
      },
      "Russia" : {
        "A": "Russia",
        "B": "ru",
        "C": "Russia",
        "D": "google.ru",
        "E": ""
      },
      "Rwanda" : {
        "A": "Rwanda",
        "B": "rw",
        "C": "Kigali City,Rwanda",
        "D": "google.rw",
        "E": ""
      },
      "Seychelles" : {
        "A": "Seychelles",
        "B": "sc",
        "C": "Seychelles",
        "D": "google.sc",
        "E": ""
      },
      "Sweden" : {
        "A": "Sweden",
        "B": "se",
        "C": "Sodermalm,Stockholm County,Sweden",
        "D": "google.se",
        "E": ""
      },
      "Saint Helena, Ascension and Tristan da Cunha" : {
        "A": "Saint Helena, Ascension and Tristan da Cunha",
        "B": "sh",
        "C": "Saint Helena, Ascension and Tristan da Cunha",
        "D": "google.sh",
        "E": ""
      },
      "Slovenia" : {
        "A": "Slovenia",
        "B": "si",
        "C": "Ljubljana,Slovenia",
        "D": "google.si",
        "E": ""
      },
      "Slovakia" : {
        "A": "Slovakia",
        "B": "sk",
        "C": "Slovakia",
        "D": "google.sk",
        "E": ""
      },
      "San Marino" : {
        "A": "San Marino",
        "B": "sm",
        "C": "San Marino",
        "D": "google.sm",
        "E": ""
      },
      "Senegal" : {
        "A": "Senegal",
        "B": "sn",
        "C": "Senegal",
        "D": "google.sn",
        "E": ""
      },
      "Somalia" : {
        "A": "Somalia",
        "B": "so",
        "C": "Somalia",
        "D": "google.so",
        "E": ""
      },
      "Suriname" : {
        "A": "Suriname",
        "B": "sr",
        "C": "Suriname",
        "D": "google.sr",
        "E": ""
      },
      "Chad" : {
        "A": "Chad",
        "B": "td",
        "C": "Chad",
        "D": "google.td",
        "E": ""
      },
      "Togo" : {
        "A": "Togo",
        "B": "tg",
        "C": "Togo",
        "D": "google.tg",
        "E": ""
      },
      "Tokelau" : {
        "A": "Tokelau",
        "B": "tk",
        "C": "Tokelau",
        "D": "google.tk",
        "E": ""
      },
      "Timor-Leste" : {
        "A": "Timor-Leste",
        "B": "tl",
        "C": "Timor-Leste",
        "D": "google.tl",
        "E": ""
      },
      "Turkmenistan" : {
        "A": "Turkmenistan",
        "B": "tm",
        "C": "Turkmenistan",
        "D": "google.tm",
        "E": ""
      },
      "Tunisia" : {
        "A": "Tunisia",
        "B": "tn",
        "C": "Tunisia",
        "D": "google.tn",
        "E": ""
      },
      "Tonga" : {
        "A": "Tonga",
        "B": "to",
        "C": "Tonga",
        "D": "google.to",
        "E": ""
      },
      "Trinidad and Tobago" : {
        "A": "Trinidad and Tobago",
        "B": "tt",
        "C": "Trinidad and Tobago",
        "D": "google.tt",
        "E": ""
      },
      "British Virgin Islands" : {
        "A": "British Virgin Islands",
        "B": "vg",
        "C": "British Virgin Islands",
        "D": "google.vg",
        "E": ""
      },
      "Vanuatu" : {
        "A": "Vanuatu",
        "B": "vu",
        "C": "Vanuatu",
        "D": "google.vu",
        "E": ""
      },
      "Samoa" : {
        "A": "Samoa",
        "B": "ws",
        "C": "Samoa",
        "D": "google.ws",
        "E": ""
      }
     
}

export const languages = [
{
  "language_code": "af",
  "language_name": "Afrikaans"
},
{
  "language_code": "ak",
  "language_name": "Akan"
},
{
  "language_code": "sq",
  "language_name": "Albanian"
},
{
  "language_code": "ws",
  "language_name": "Samoa"
},
{
  "language_code": "am",
  "language_name": "Amharic"
},
{
  "language_code": "ar",
  "language_name": "Arabic"
},
{
  "language_code": "hy",
  "language_name": "Armenian"
},
{
  "language_code": "az",
  "language_name": "Azerbaijani"
},
{
  "language_code": "eu",
  "language_name": "Basque"
},
{
  "language_code": "be",
  "language_name": "Belarusian"
},
{
  "language_code": "bem",
  "language_name": "Bemba"
},
{
  "language_code": "bn",
  "language_name": "Bengali"
},
{
  "language_code": "bh",
  "language_name": "Bihari"
},
{
  "language_code": "xx-bork",
  "language_name": "Bork, bork, bork!"
},
{
  "language_code": "bs",
  "language_name": "Bosnian"
},
{
  "language_code": "br",
  "language_name": "Breton"
},
{
  "language_code": "bg",
  "language_name": "Bulgarian"
},
{
  "language_code": "bt",
  "language_name": "Bhutanese"
},
{
  "language_code": "km",
  "language_name": "Cambodian"
},
{
  "language_code": "ca",
  "language_name": "Catalan"
},
{
  "language_code": "chr",
  "language_name": "Cherokee"
},
{
  "language_code": "ny",
  "language_name": "Chichewa"
},
{
  "language_code": "zh-cn",
  "language_name": "Chinese (Simplified)"
},
{
  "language_code": "zh-tw",
  "language_name": "Chinese (Traditional)"
},
{
  "language_code": "co",
  "language_name": "Corsican"
},
{
  "language_code": "hr",
  "language_name": "Croatian"
},
{
  "language_code": "cs",
  "language_name": "Czech"
},
{
  "language_code": "da",
  "language_name": "Danish"
},
{
  "language_code": "nl",
  "language_name": "Dutch"
},
{
  "language_code": "xx-elmer",
  "language_name": "Elmer Fudd"
},
{
  "language_code": "en",
  "language_name": "English"
},
{
  "language_code": "eo",
  "language_name": "Esperanto"
},
{
  "language_code": "et",
  "language_name": "Estonian"
},
{
  "language_code": "ee",
  "language_name": "Ewe"
},
{
  "language_code": "fo",
  "language_name": "Faroese"
},
{
  "language_code": "tl",
  "language_name": "Filipino"
},
{
  "language_code": "fi",
  "language_name": "Finnish"
},
{
  "language_code": "fr",
  "language_name": "French"
},
{
  "language_code": "fy",
  "language_name": "Frisian"
},
{
  "language_code": "gaa",
  "language_name": "Ga"
},
{
  "language_code": "gl",
  "language_name": "Galician"
},
{
  "language_code": "ka",
  "language_name": "Georgian"
},
{
  "language_code": "de",
  "language_name": "German"
},
{
  "language_code": "el",
  "language_name": "Greek"
},
{
  "language_code": "kl",
  "language_name": "Greenlandic"
},
{
  "language_code": "gn",
  "language_name": "Guarani"
},
{
  "language_code": "gu",
  "language_name": "Gujarati"
},
{
  "language_code": "xx-hacker",
  "language_name": "Hacker"
},
{
  "language_code": "ht",
  "language_name": "Haitian Creole"
},
{
  "language_code": "ha",
  "language_name": "Hausa"
},
{
  "language_code": "haw",
  "language_name": "Hawaiian"
},
{
  "language_code": "iw",
  "language_name": "Hebrew"
},
{
  "language_code": "hi",
  "language_name": "Hindi"
},
{
  "language_code": "hu",
  "language_name": "Hungarian"
},
{
  "language_code": "is",
  "language_name": "Icelandic"
},
{
  "language_code": "ig",
  "language_name": "Igbo"
},
{
  "language_code": "id",
  "language_name": "Indonesian"
},
{
  "language_code": "ia",
  "language_name": "Interlingua"
},
{
  "language_code": "ga",
  "language_name": "Irish"
},
{
  "language_code": "it",
  "language_name": "Italian"
},
{
  "language_code": "ja",
  "language_name": "Japanese"
},
{
  "language_code": "jw",
  "language_name": "Javanese"
},
{
  "language_code": "kn",
  "language_name": "Kannada"
},
{
  "language_code": "kk",
  "language_name": "Kazakh"
},
{
  "language_code": "rw",
  "language_name": "Kinyarwanda"
},
{
  "language_code": "rn",
  "language_name": "Kirundi"
},
{
  "language_code": "xx-klingon",
  "language_name": "Klingon"
},
{
  "language_code": "kg",
  "language_name": "Kongo"
},
{
  "language_code": "ko",
  "language_name": "Korean"
},
{
  "language_code": "kri",
  "language_name": "Krio (Sierra Leone)"
},
{
  "language_code": "ku",
  "language_name": "Kurdish"
},
{
  "language_code": "ckb",
  "language_name": "Kurdish (Soranî)"
},
{
  "language_code": "ky",
  "language_name": "Kyrgyz"
},
{
  "language_code": "lo",
  "language_name": "Laothian"
},
{
  "language_code": "la",
  "language_name": "Latin"
},
{
  "language_code": "lv",
  "language_name": "Latvian"
},
{
  "language_code": "ln",
  "language_name": "Lingala"
},
{
  "language_code": "lt",
  "language_name": "Lithuanian"
},
{
  "language_code": "loz",
  "language_name": "Lozi"
},
{
  "language_code": "lg",
  "language_name": "Luganda"
},
{
  "language_code": "ach",
  "language_name": "Luo"
},
{
  "language_code": "mk",
  "language_name": "Macedonian"
},
{
  "language_code": "mg",
  "language_name": "Malagasy"
},
{
  "language_code": "my",
  "language_name": "Malay"
},
{
  "language_code": "ml",
  "language_name": "Malayalam"
},
{
  "language_code": "mt",
  "language_name": "Maltese"
},
{
  "language_code": "mv",
  "language_name": "Maldives"
},
{
  "language_code": "mi",
  "language_name": "Maori"
},
{
  "language_code": "mr",
  "language_name": "Marathi"
},
{
  "language_code": "mfe",
  "language_name": "Mauritian Creole"
},
{
  "language_code": "mo",
  "language_name": "Moldavian"
},
{
  "language_code": "mn",
  "language_name": "Mongolian"
},
{
  "language_code": "sr-me",
  "language_name": "Montenegrin"
},
{
  "language_code": "ne",
  "language_name": "Nepali"
},
{
  "language_code": "pcm",
  "language_name": "Nigerian Pidgin"
},
{
  "language_code": "nso",
  "language_name": "Northern Sotho"
},
{
  "language_code": "no",
  "language_name": "Norwegian"
},
{
  "language_code": "nn",
  "language_name": "Norwegian (Nynorsk)"
},
{
  "language_code": "oc",
  "language_name": "Occitan"
},
{
  "language_code": "or",
  "language_name": "Oriya"
},
{
  "language_code": "om",
  "language_name": "Oromo"
},
{
  "language_code": "ps",
  "language_name": "Pashto"
},
{
  "language_code": "fa",
  "language_name": "Persian"
},
{
  "language_code": "xx-pirate",
  "language_name": "Pirate"
},
{
  "language_code": "pl",
  "language_name": "Polish"
},
{
  "language_code": "pt",
  "language_name": "Portuguese"
},
{
  "language_code": "pt-br",
  "language_name": "Portuguese (Brazil)"
},
{
  "language_code": "pt-pt",
  "language_name": "Portuguese (Portugal)"
},
{
  "language_code": "pa",
  "language_name": "Punjabi"
},
{
  "language_code": "qu",
  "language_name": "Quechua"
},
{
  "language_code": "ro",
  "language_name": "Romanian"
},
{
  "language_code": "rm",
  "language_name": "Romansh"
},
{
  "language_code": "nyn",
  "language_name": "Runyakitara"
},
{
  "language_code": "ru",
  "language_name": "Russian"
},
{
  "language_code": "gd",
  "language_name": "Scots Gaelic"
},
{
  "language_code": "sr",
  "language_name": "Serbian"
},
{
  "language_code": "sh",
  "language_name": "Serbo-Croatian"
},
{
  "language_code": "st",
  "language_name": "Sesotho"
},
{
  "language_code": "tn",
  "language_name": "Setswana"
},
{
  "language_code": "crs",
  "language_name": "Seychellois Creole"
},
{
  "language_code": "sn",
  "language_name": "Shona"
},
{
  "language_code": "sd",
  "language_name": "Sindhi"
},
{
  "language_code": "si",
  "language_name": "Sinhalese"
},
{
  "language_code": "sk",
  "language_name": "Slovak"
},
{
  "language_code": "sl",
  "language_name": "Slovenian"
},
{
  "language_code": "so",
  "language_name": "Somali"
},
{
  "language_code": "es",
  "language_name": "Spanish"
},
{
  "language_code": "es-419",
  "language_name": "Spanish (Latin American)"
},
{
  "language_code": "su",
  "language_name": "Sundanese"
},
{
  "language_code": "sw",
  "language_name": "Swahili"
},
{
  "language_code": "sv",
  "language_name": "Swedish"
},
{
  "language_code": "tg",
  "language_name": "Tajik"
},
{
  "language_code": "ta",
  "language_name": "Tamil"
},
{
  "language_code": "tt",
  "language_name": "Tatar"
},
{
  "language_code": "te",
  "language_name": "Telugu"
},
{
  "language_code": "th",
  "language_name": "Thai"
},
{
  "language_code": "ti",
  "language_name": "Tigrinya"
},
{
  "language_code": "to",
  "language_name": "Tonga"
},
{
  "language_code": "lua",
  "language_name": "Tshiluba"
},
{
  "language_code": "tum",
  "language_name": "Tumbuka"
},
{
  "language_code": "tr",
  "language_name": "Turkish"
},
{
  "language_code": "tk",
  "language_name": "Turkmen"
},
{
  "language_code": "tw",
  "language_name": "Twi"
},
{
  "language_code": "ug",
  "language_name": "Uighur"
},
{
  "language_code": "uk",
  "language_name": "Ukrainian"
},
{
  "language_code": "ur",
  "language_name": "Urdu"
},
{
  "language_code": "uz",
  "language_name": "Uzbek"
},
{
  "language_code": "vu",
  "language_name": "Vanuatu"
},
{
  "language_code": "vi",
  "language_name": "Vietnamese"
},
{
  "language_code": "cy",
  "language_name": "Welsh"
},
{
  "language_code": "wo",
  "language_name": "Wolof"
},
{
  "language_code": "xh",
  "language_name": "Xhosa"
},
{
  "language_code": "yi",
  "language_name": "Yiddish"
},
{
  "language_code": "yo",
  "language_name": "Yoruba"
},
{
  "language_code": "zu",
  "language_name": "Zulu"
}
]
